import { useEffect, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import * as Sentry from "@sentry/nextjs";

export default function ActivityReasonForApplying({ state, onChange }) {
  return (
    <>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Reason for Applying</strong>
            <br />
            Choose one reason that best describes why you are applying for an EIN.
          </Tooltip>
        }
      >
        <Form.Group controlId="activityReasonForApplying">
          <Form.Label>Closest reason for applying</Form.Label>
          <Form.Control as="select" required value={state.activityReasonForApplying} onChange={onChange}>
            <option value="">Please Select</option>
            <option value="started_business">Started New Business</option>
            <option value="hired_employees">Hired Employees</option>
            <option value="banking_purposes">Banking Purposes</option>
            <option value="changed_organization">Changed Type of Organization</option>
            <option value="purchased_business">Purchased Business</option>
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please provide a reason for applying</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </>
  );
}
